import { observer } from 'mobx-react';
import { Group } from 'react-aria-components/Group';

import { NumberRangePickerTranslation } from '../../../../localization/ModuleTranslation';
import NumberField from '../../../../ui/NumberField/NumberField';
import Slider from '../../../../ui/Slider/Slider';
import css from './NumberRangePicker.css';
import NumberRangePickerState from './NumberRangePickerState';

interface NumberRangePickerProps {
  label: string;
  state: NumberRangePickerState;
  translation: NumberRangePickerTranslation;
}

const NumberRangePicker = observer(({ state, translation, label }: NumberRangePickerProps) => {
  return (
    <>
      <Slider
        aria-label={label}
        thumbLabels={[translation.from, translation.to]}
        minValue={state.minValue}
        maxValue={state.maxValue}
        value={state.value}
        step={state.step}
        onChange={state.setValue}
      />
      <Group className={css.fields} aria-label={label}>
        <NumberField label={translation.from} value={state.min} onChange={state.setMin} />
        <NumberField label={translation.to} value={state.max} onChange={state.setMax} />
      </Group>
    </>
  );
});

export default NumberRangePicker;
